module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-experiment2-cropped.2d81e046.jpg";